import { PetSpeciesFilterableType } from './pet';
import { ProductType } from './user';

// // TODO: Remove this interface once perks come from endpoint
export interface PerkFilters {
  productType?: Array<ProductType>;
  species?: Array<PetSpeciesFilterableType>;
  petMonthsMax?: number;
  petDaysMax?: number;
  perkApparence?: number;
  perkPosition?: number;
  perkApparencePosition?: number;
}

export interface PerkWidget {
  heading: string;
  description: string;
  image: string;
  imageFeatured?: string;
  widgetSize?: WidgetSize;
  footerText?: string;
  redirectUri?: string;
  buttonLabel?: string;
}

export interface PerkCheckbox {
  copy: string;
  required: boolean;
  checked: boolean;
}

export enum WidgetSize {
  Large = 'Large',
  Medium = 'Medium',
  Small = 'Small',
}

export interface PerkModal {
  copy: {
    heading: string;
    main: string;
    keyPoints?: string;
    tagline?: string;
    smallprint?: string;
    headingBottom?: string;
  };
  images: {
    header: string;
    main: string;
    secondary?: string;
  };
  checkbox?: PerkCheckbox;
  button: {
    copy: string;
    url?: string;
    checkboxStyle?: boolean;
    route?: string;
  };
  options?: {
    noTerms?: boolean;
    termsLink?: string;
  };
}

export interface Perk {
  id: number;
  name: string;
  filters?: PerkFilters; // TODO: Remove this once perks come from endpoint
  disabled?: boolean;
  color: string;
  widget: PerkWidget;
  modal?: PerkModal;
  voucher?: PerkVoucher;
  hasVoucher?: boolean;
  email?: PerkVoucherEmail;
  tag?: string;
  order?: number;
  hasUniqueCode: boolean;
  shortCode: string;
}

export interface PerkVoucher {
  buttonCopy?: string;
  code: string;
  discount?: string; // TODO: Remove this once voucher email is sent from the back-end
  heading?: string;
  helpText?: string;
  url: string;
}

export interface PerkVoucherCode {
  ExpirationDate: string;
  PromotionCode: string;
}

export interface PerkVoucherEmail {
  subject: string;
  voucherCode?: string;
  buttonUrl: string;
  preview: string;
  heading1: string;
  heading2: string;
  content1: string;
  content2: string;
  buttonCopy1: string;
  buttonCopy2: string;
  image1: string;
  color: string;
  footerSeparator?: string;
  footerTaClink?: string;
  footerContent?: string;
}
